import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import InputMoney from '../../inputs/money/input-money';
import { FormProps } from '../../../shared/interfaces/form';

interface FormCurrencyProps {
  item: FormProps;
  index: number;
  baseId: string;
  errors: any;
  control: any;
  isDisabled: boolean;
  setValue: (name: string, value: any) => void;
  getValues: (name?: string | string[]) => any;
}

const FormCurrency = ({
  item,
  index,
  baseId,
  errors,
  control,
  isDisabled,
  setValue,
  getValues
}: FormCurrencyProps) => {
  const [ isDisabledInput, setIsDisabledInput ] = useState(false);
  
  const handleCurrencyChange = (e: React.ChangeEvent<HTMLInputElement>, onChange: any) => {
    onChange(e.target.value);
  };

  useEffect(() => {
      const page = window.location.hash.split('/')[1];
  
      if(page.toLocaleLowerCase().includes('list')) {
        setIsDisabledInput(true);
      }
  
    }, []);
  
  return (
    <Controller
      key={`input-money-${index}-${baseId}`}
      name={item.name}
      control={control}
      defaultValue={item.value || 0}
      rules={item.rules}
      render={({ field }) => (
        <div className={`form-input-wrapper ${item.fullWidth ? 'full-width' : ''}`}>
          <InputMoney
            value={field.value}
            onChange={(e) => handleCurrencyChange(e, field.onChange)}
            onBlur={field.onBlur}
            name={field.name}
            placeholder={item.placeholder}
            width="100%"
            height={item.height}
            disabled={isDisabled || isDisabledInput}
          />
        </div>
      )}
    />
  );
};

export default FormCurrency;